export function getDisplayNamesFromPeoplePicker(str) {
  const userArray = JSON.tryParse(str, []);
  let names = [];
  for (const user of userArray) {
    names.push(user.displayName);
  }
  return names.join(", ");
}
